import { Button, Flex, Heading, Stack, VStack } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { ContactForm } from '../../components/forms/ContactForm';
import { NotificationsForm } from '../../../../../packages/ui/forms/NotificationsForm';
import { ProfileForm } from '../../components/forms/ProfileForm';
import { MainTemplate } from '../../templates/MainTemplate';
import { ProfileLinks } from './components/Links';
import { useTheme } from '../../contexts/ThemeProvider';
import { Logo } from '../../components/atoms/Logo';
import { ProfileCard } from '../../components/organisms/ProfileCard';
import { IoClose } from 'react-icons/io5';
import { Econometro } from './components/Econometro';
import { Plans } from './components/Plans';
import { Dependents } from './components/Dependents';
import { PlansIphone } from './components/PlansIphone';
import { Footer } from '../../components/organisms/Footer';
import { EconometroList } from './components/EconometroList';

function ProfileSubPageTemplate({ children }: PropsWithChildren) {
  const naviate = useNavigate();

  return (
    <VStack
      spacing={5}
      height={'100%'}
      marginTop={{
        base: '0px',
        md: '50px',
      }}
      width={'100%'}
    >
      {children}
      <Button variant={''} marginTop={'10px'} onClick={() => naviate(-1)}>
        <Heading color="#747474" fontWeight={'600'} fontFamily={'Glory'} fontSize={'18px'}>
          VOLTAR
        </Heading>
      </Button>
    </VStack>
  );
}

export function ProfilePage() {
  const { colors } = useTheme();

  const navigate = useNavigate();
  const location = useLocation();

  return (
    <MainTemplate hideTopMenu>
      <VStack
        marginTop={{
          base: '0px',
          lg: '20px',
        }}
        marginBottom={{
          base: '100px',
          lg: '0px',
        }}
        spacing={5}
        width={{ base: '90%' }}
      >
        <Stack
          spacing={5}
          position={'fixed'}
          bg="#F1F4F5"
          display={{
            base: 'flex',
            lg: 'none',
          }}
          zIndex={100}
          padding={'15px 20px'}
          justifyContent={'space-between'}
          alignItems={'center'}
          direction={'row'}
          width={'100%'}
        >
          <Logo height={'45px'} width={'auto'} objectFit="contain" />
          <Button variant={'unstyled'} onClick={() => navigate(-1)}>
            <IoClose size={35} color={colors.primaryColor} />
          </Button>
        </Stack>
        <VStack
          spacing={4}
          w={'100%'}
          paddingTop={{
            base: '90px',
            lg: '0px',
          }}
        >
          {(location.pathname === '/perfil' || location.pathname === '/perfil/econometro') && (
            <Flex
              width={'100%'}
              direction={{
                base: 'column',
                lg: 'row',
              }}
              justifyContent={'space-between'}
            >
              <ProfileCard />
              <Econometro />
            </Flex>
          )}

          <VStack width={'100%'}>
            <Routes>
              <Route path="/" element={<ProfileLinks />} />
              <Route
                path="/meus-dados"
                element={
                  <ProfileSubPageTemplate>
                    <ProfileForm />
                  </ProfileSubPageTemplate>
                }
              />
              <Route
                path="/notificacoes"
                element={
                  <ProfileSubPageTemplate>
                    <NotificationsForm />
                  </ProfileSubPageTemplate>
                }
              />
              <Route
                path="/dependentes"
                element={
                  <ProfileSubPageTemplate>
                    <Dependents />
                  </ProfileSubPageTemplate>
                }
              />
              <Route
                path="/contato"
                element={
                  <ProfileSubPageTemplate>
                    <ContactForm />
                  </ProfileSubPageTemplate>
                }
              />
              <Route
                path="/econometro"
                element={
                  <ProfileSubPageTemplate>
                    <EconometroList />
                  </ProfileSubPageTemplate>
                }
              />
              <Route
                path="/planos/purchase-subscription-mobile/:token"
                element={<ProfileSubPageTemplate>{<PlansIphone />}</ProfileSubPageTemplate>}
              />
              <Route path="/planos" element={<ProfileSubPageTemplate>{<Plans />}</ProfileSubPageTemplate>} />
            </Routes>
          </VStack>
        </VStack>

        <Footer />
      </VStack>
    </MainTemplate>
  );
}
